import PropTypes from 'prop-types';
import { BsCheckCircle, BsExclamationTriangle, BsInfoCircle, BsXCircle } from 'react-icons/bs';
import { twMerge } from 'tailwind-merge';

import Button from '#globalComponents/Button/Button';

const TONES = {
	info: { box: 'border-primary-200 bg-primary-100', text: 'text-primary-700', icon: BsInfoCircle },
	success: { box: 'border-success-500/40 bg-success-200', text: 'text-success-700', icon: BsCheckCircle },
	caution: { box: 'border-caution-500/40 bg-caution-200', text: 'text-caution-700', icon: BsExclamationTriangle },
	warning: { box: 'border-warning-500/40 bg-warning-200', text: 'text-warning-700', icon: BsXCircle },
};

const Alert = ({ tone = 'info', title, children, icon, actionLabel, onAction, className }) => {
	const { box, text, icon: DefaultIcon } = TONES[tone];
	const Icon = icon ?? DefaultIcon;

	return (
		<div className={twMerge(`flex items-start gap-3 rounded-card border p-4 ${box}`, className)}>
			<Icon className={`mt-0.5 h-4 w-4 flex-shrink-0 ${text}`} />
			<div className="min-w-0 flex-1">
				{title && <h3 className={`text-sm font-semibold ${text}`}>{title}</h3>}
				{children && <div className={`text-sm ${text} ${title ? 'mt-0.5' : ''}`}>{children}</div>}
			</div>
			{actionLabel && onAction && (
				<Button variant="solid" size="sm" onClick={onAction}>
					{actionLabel}
				</Button>
			)}
		</div>
	);
};

Alert.propTypes = {
	tone: PropTypes.oneOf(Object.keys(TONES)),
	title: PropTypes.node,
	children: PropTypes.node,
	icon: PropTypes.elementType,
	actionLabel: PropTypes.string,
	onAction: PropTypes.func,
	className: PropTypes.string,
};

export default Alert;
